import React, { useEffect, useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { useSelector } from "react-redux";
import { updateDepartment } from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import { useDispatch } from "react-redux";
import PopupCard from "../../../../Auth/PopupCard";
import { createPortal } from "react-dom";
const EditDepartment = ({ onOpen, onClose }) => {
  const dispatch = useDispatch();

  //Selected department DATA
  const selectedDepartment = useSelector(
    (state) => state.orgSetup.selectedDepartment,
  );
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("Active");
  const [popup, setPopup] = useState({
    visible: false,
    type: "success",
    title: "Success",
    message: "",
  });

  useEffect(() => {
    if (selectedDepartment) {
      setName(selectedDepartment.name || "");
      setType(selectedDepartment.department_type || "");
      setStatus(selectedDepartment.isActive ? "Active" : "Inactive");
    }
  }, [selectedDepartment]);

  //Update DATA
  const handleUpdate = () => {
    if (!selectedDepartment) return;

    const payload = {
      name: name.trim(),
      department_type: type || null,
      isActive: status === "Active",
    };

    dispatch(updateDepartment({ id: selectedDepartment._id, payload }))
      .unwrap()
      .then((res) => {
        setPopup({
          visible: true,
          type: "success",
          title: "Success",
          message: res?.message || "Department updated successfully!",
        });
        setTimeout(() => {
          setPopup((prev) => ({ ...prev, visible: false }));
          onClose();
        }, 2000);
      })
      .catch((err) => {
        console.error("Update failed:", err);
        setPopup({
          visible: true,
          type: "error",
          title: "Error",
          message:
            typeof err === "string"
              ? err
              : err?.message || "Failed to update department.",
        });
        setTimeout(() => {
          setPopup((prev) => ({ ...prev, visible: false }));
        }, 3000);
      });
  };

  return (
    <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
      <div className="p-6">
        {/* Top Inputs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Department Name */}
          <div>
            <label className="text-sm text-gray-700">Department Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
            />
          </div>

          {/* Department Type */}
          <div>
            <label className="text-sm text-gray-700">Department Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
            >
              <option value="">Select Type</option>
              <option value="Core">Core</option>
              <option value="Support">Support</option>
            </select>
          </div>

          {/* Status */}
          <div>
            <label className="text-sm text-gray-700">
              Status <span className="text-red-500">*</span>
            </label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* Success Message handled via PopupCard */}
        {popup.visible &&
          createPortal(
            <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-40 px-4">
              <PopupCard
                type={popup.type}
                title={popup.title}
                message={popup.message}
              />
            </div>,
            document.body,
          )}

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-8">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-[#06513D] text-[#06513D] rounded-md"
          >
            Cancel
          </button>

          <button
            onClick={handleUpdate}
            className="px-6 py-2 bg-[#06513D] text-white rounded-md"
          >
            Add Details
          </button>
        </div>
      </div>
    </DialogBox>
  );
};

export default EditDepartment;
